import { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { COMPANY_FRIENDLY, FRIENDLY_URL } from "../core/constants";
import {
  checkFunctionalCookiesAllowed,
  removeFunctionalCookiesAllowedCookie,
  setFunctionalCookiesAllowed,
} from "../core/cookie";
import { loadGA, removeGA } from "../core/google";

const CookieSettings = () => {
  const [advertisingCookies, setAdvertisingCookies] = useState(false);
  const [functionalCookies, setFunctionalCookies] = useState(true);

  useEffect(() => {
    if (checkFunctionalCookiesAllowed()) {
      setFunctionalCookies(true);
    } else {
      setFunctionalCookies(false);
    }
  }, []);

  const onAdvertisingCookiesChange = (e) => {
    setAdvertisingCookies(e.target.checked);
  };

  const onFunctionalCookiesChange = (e) => {
    setFunctionalCookies(e.target.checked);

    if (e.target.checked) {
      setFunctionalCookiesAllowed();
      loadGA();
    } else {
      removeFunctionalCookiesAllowedCookie();
      removeGA();
    }
  };

  return (
    <>
      <Header />
      <section className="relative flex w-full bg-purple-800">
        <div className="container pt-[170px] pb-16 mx-auto ">
          <h1 className="title-font px-8 text-1xl md:text-2xl lg:text-3xl font-medium text-white leading-tight line-height-tight drop-shadow-lg">
            Cookies Settings
          </h1>
        </div>
      </section>

      <section className="text-gray-600 body-font bg-gray-100 pt-4 pb-1">
        <div className="container px-5 mt-4 mb-8 mx-auto flex flex-wrap">
          <a
            href="/terms/cookies"
            className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium bg-purple-800 text-white hover:cursor-pointer"
          >
            👈 See our cookie policy
          </a>
        </div>
      </section>

      <div className="container px-5 py-12 mx-auto flex flex-wrap text-gray-600 body-font">
        <div className="text-base">
          <p className="mb-4">
            <span className="text-indigo-800 font-bold">{FRIENDLY_URL}</span>{" "}
            uses cookies and similar technologies to improve your experience and
            for advertising and marketing purposes. Review and manage your
            cookie settings below to control your privacy. For more information
            on how we use cookies, please see our{" "}
            <a
              href="/terms/cookies"
              className="text-purple-600 hover:cursor-pointer"
            >
              Cookies Policy
            </a>
            .
          </p>
        </div>

        <div className="w-full xl:w-2/3 mx-auto">
          <section className="bg-gray-100 rounded-lg p-4 my-4 w-full">
            <div className="flex flex-row justify-between">
              <h2 className="text-lg">Advertising</h2>
              <div className="">
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    checked={advertisingCookies}
                    id="advertising-cookies"
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    onChange={onAdvertisingCookiesChange}
                  />
                  <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                  <span className="ml-2 ms-3 text-sm font-medium text-gray-900">
                    {advertisingCookies ? "Enabled" : "Disabled"}
                  </span>
                </label>
              </div>
            </div>
            <p className="text-sm mb-4">
              Advertising cookies and similar technologies on {FRIENDLY_URL}{" "}
              allow us to place targeted {COMPANY_FRIENDLY} advertisements on
              other sites you visit and measure your engagement with those ads.
            </p>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th className="py-4 px-2" scope="col">
                      <span className="font-bold">Technology</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Purpose</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Type</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Lifespan</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Further information</span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td className="py-4" colSpan="5">
                      <p className="font-bold text-center">
                        Advertising Cookies
                      </p>
                    </td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="text-center py-8" colSpan="5">
                      None
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="bg-gray-100 rounded-lg p-4 my-4 w-full">
            <div className="flex flex-row justify-between">
              <h2 className="text-lg">Functional</h2>
              <div className="">
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    checked={functionalCookies}
                    id="functional-cookies"
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    onChange={onFunctionalCookiesChange}
                  />
                  <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                  <span className="ml-2 ms-3 text-sm font-medium text-gray-900">
                    {functionalCookies ? "Enabled" : "Disabled"}
                  </span>
                </label>
              </div>
            </div>
            <p className="text-sm mb-4">
              Functional cookies provide enhanced functions, performance and
              services on the website.
            </p>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th className="py-4 px-2" scope="col">
                      <span className="font-bold">Technology</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Purpose</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Type</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Lifespan</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Further information</span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                    <th scope="row" className="py-4 vertical-align-top px-2">
                      <span className="font-bold">Google</span>
                    </th>
                    <td className="py-4 vertical-align-top">
                      We use the Google Analytics cookies as listed in our
                      Cookie Policy.
                    </td>
                    <td>Persistent</td>
                    <td>1 year</td>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="bg-gray-100 rounded-lg p-4 my-4 w-full">
            <div className="flex flex-row justify-between">
              <h2 className="text-lg">Essential</h2>
            </div>
            <p className="text-sm mb-4">
              Essential cookies that are necessary for basic website and app
              functionality. These cannot be disabled as our systems cannot work
              without them.
            </p>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th className="py-4 px-2" scope="col">
                      <span className="font-bold">Technology</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Purpose</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Type</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Lifespan</span>
                    </th>
                    <th scope="col">
                      <span className="font-bold">Further information</span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                    <th scope="row" className="py-4 vertical-align-top px-2">
                      <span className="font-bold">Zeropa</span>
                    </th>
                    <td className="py-4 vertical-align-top">
                      We use a consent cookie to remember your cookie
                      preferences. If you choose not to accept cookies, the
                      consent window will ask your preference on every visit.
                    </td>
                    <td>Persistent or Session</td>
                    <td>1 year</td>
                    <td>
                      If you select to reject cookies, we set a session only
                      cookie so that {FRIENDLY_URL} works correctly. You will be
                      asked your preference on your return.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CookieSettings;
